import {
  type Integration,
  type Integrations,
} from "../../../portals/messagemedia/hooks";
export const hasIntegration = (
  integrations: Integration[],
  integrationToCheck: Integrations
) =>
  !!integrations.find(
    (integration) =>
      integration.integration === integrationToCheck &&
      integration.status === "ACTIVE"
  );
